import { Box, Button } from '@material-ui/core';
import React from 'react';

import { ConditionalWrapper } from '@/components/shared/components/ConditionalWrapper';
import { ICON_WITH_CIRCLE_SIZE_VALUES } from '@/components/shared/components/config';
import { IconWithCircle } from '@/components/shared/components/IconWithCircle';
import { MoreActionsMenu } from '@/components/shared/components/MoreActionsMenu/MoreActionsMenu';
import { Text } from '@/components/shared/components/Text';
import { useNotificationsContext } from '@/contexts/NotificationsContext/NotificationsContext';

export function SizedIconWithCircle({
  backgroundColor,
  customBorderRadius,
  iconColor,
  iconName,
  variant,
  copyToClipboard,
  actionsOptionsArray,
}: {
  border?: string;
  variant: 'small' | 'medium' | 'large';
  backgroundColor: string;
  iconColor?: string;
  customBorderRadius: string | number;
  iconName: string;
  copyToClipboard?: { value: string; textId: string };
  actionsOptionsArray?: {
    display: string | React.ReactElement;
    onClick: () => void;
    iconName?: string;
  }[];
}) {
  const {
    actions: { setSnackbarNotification },
  } = useNotificationsContext();

  const copyAction = copyToClipboard && [
    {
      display: (
        <>
          <Text tId={copyToClipboard?.textId} />
        </>
      ),
      iconName: 'copy',
      onClick: () => {
        navigator.clipboard.writeText(copyToClipboard?.value);
        setSnackbarNotification({
          msg: 'ID_COPIED_SUCCESSFULLY',
          level: 'success',
        });
      },
    },
  ];

  const actionsOptions = copyToClipboard ? copyAction : actionsOptionsArray;

  const MoreActionsMenuWrapper = (children) =>
    actionsOptions ? (
      <MoreActionsMenu actionsOptionsArray={actionsOptions}>
        <Box bgcolor={backgroundColor} borderRadius={customBorderRadius}>
          <Button
            style={{
              width: ICON_WITH_CIRCLE_SIZE_VALUES[variant].circleSize,
              height: ICON_WITH_CIRCLE_SIZE_VALUES[variant].circleSize,
              padding: 0,
              minWidth: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {children}
          </Button>
        </Box>
      </MoreActionsMenu>
    ) : (
      <></>
    );

  return (
    <ConditionalWrapper condition={!!actionsOptions} wrapper={(children) => MoreActionsMenuWrapper(children)}>
      <IconWithCircle
        height={ICON_WITH_CIRCLE_SIZE_VALUES[variant].circleSize}
        width={ICON_WITH_CIRCLE_SIZE_VALUES[variant].circleSize}
        bgcolor={actionsOptions ? 'none' : backgroundColor}
        className="material-icons-outlined"
        borderRadius={customBorderRadius}
        iconProps={{
          style: {
            color: iconColor,
            fontSize: ICON_WITH_CIRCLE_SIZE_VALUES[variant].fontSize,
            cursor: actionsOptions ? 'pointer' : 'default',
          },
        }}
      >
        {iconName}
      </IconWithCircle>
    </ConditionalWrapper>
  );
}
